import React from 'react';
import FormButton from '../FormButton';
import SvgIcon from '../SvgIcon';

const LoadingButton = ({
  children, loading, className, type="submit", ...attrs
}) => {
  let classes = '';
  let iconClasses = '';

  if ( className ) {
    classes += ` ${className}`;
  }

  if ( loading ) {
    iconClasses += ' ' + 'animation-rotate';
  }

  return (
    <FormButton className={classes} disabled={!!loading} type={type} {...attrs}>
      {loading ? <SvgIcon icon="icon-refresh" iconClasses={iconClasses} baseline /> : children}
    </FormButton>
  );
};

export default LoadingButton;
